var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container h-100 th-px-24-md"},[_c('div',{staticClass:"d-flex align-items-center justify-content-center flex-column h-100 th-py-12 th-py-48-md"},[_c('router-view',{attrs:{"on-submit":_vm.onSubmit}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }